import { useEffect, useState } from "react";
import { DataResult, State, toDataSourceRequestString } from "@progress/kendo-data-query";
import {
    Grid,
    GridColumn,
    GridDataStateChangeEvent,
} from "@progress/kendo-react-grid";
import { ColumnMenuDefaultFilter } from "../Shared/Components/ColumnMenuFilter";
import { useNavigate } from "react-router-dom";
import WorkHourService from "../Shared/Services/WorkHourService";
import SweetAlertService from "../../../services/SweetAlertService";
import { DeletePopupConfirmationMessage } from "../Shared/Constants/AdminModuleConstants";

export const WorkHourList = () => {
    let initialState = { dataState: { skip: 0, take: 20 }, result: { data: [], total: 0 } };

    const [result, setResult] = useState<DataResult>(initialState.result);
    const [dataState, setDataState] = useState<State>(initialState.dataState);

    useEffect(() => {
        fetchData(dataState);
    }, []);

    const fetchData = (state: State) => {
        const queryStr = `${toDataSourceRequestString(state)}`; // Serialize the state
        WorkHourService.getWorkHours(queryStr)
            .then((response) => {
                setResult({ data: response.data.data, total: response.data.total });
                setDataState(state);
            });
    }
    const dataStateChange = (event: GridDataStateChangeEvent) => {
        setDataState(event.dataState);
        fetchData(event.dataState);
    };

    const navigate = useNavigate();
    const renderActionCell = (props: any) => {
        return (
            <td>
                {/*<a className="btn btn-primary btn-sm" onClick={() => navigate(`/updateWorkHour/${props.dataItem.id}`)}>*/}
                {/*    <span className="k-icon k-i-edit k-icon-color"></span>*/}
                {/*</a>*/}
                {/*<a className="btn btn-primary btn-sm ms-1" onClick={() => navigate(`/viewWorkHour/${props.dataItem.id}`)}>*/}
                {/*    <span className="k-icon k-i-information k-icon-color"></span>*/}
                {/*</a>*/}
                <a className="btn btn-primary btn-sm ms-1" onClick={() => onDelete(props.dataItem.id)}>
                    <span className="k-icon k-i-delete k-icon-color"></span>
                </a>
            </td>
        );
    };

    const onDelete = (id: any) => {
        SweetAlertService.confirm('Delete', DeletePopupConfirmationMessage).then((res) => {
            if (res.isConfirmed) {
                WorkHourService.deleteWorkHourById(id).then((res) => {
                    if (res) {
                        fetchData(dataState);
                    }
                }).catch((error) => {
                    console.log(error);
                })
            }
        })
    }

    const renderLinkCell = (props: any) => {
        const { dataItem } = props;
        return (
            <td className="name-as-link">
                <a onClick={() => navigate(`/workhourDetails/${dataItem.id}`)}>{dataItem.countryName}</a>
            </td>
        );
    };

    return (
        <div className="card card-default">
            <div className="card-header">
                <h4>Contracts
                    <button
                        title="Add new"
                        className="btn btn-primary pull-right"
                        onClick={() => navigate('/addWorkHour')}>
                        Create contract
                    </button>
                </h4>
            </div>
            <div className="card-body card-body-custom">
                <Grid
                    sortable={true}
                    pageable={{
                        buttonCount: 4,
                        pageSizes: [5, 10, 15, 20],
                    }}
                    {...dataState}
                    data={result}
                    onDataStateChange={dataStateChange}>
                    <GridColumn field="countryName" cell={renderLinkCell} title="Country" columnMenu={ColumnMenuDefaultFilter} width="250px" />
                    <GridColumn field="contract" title="Contract" columnMenu={ColumnMenuDefaultFilter} width="250px" />
                    <GridColumn field="role" title="Role" columnMenu={ColumnMenuDefaultFilter} width="250px" />
                    <GridColumn field="subRole" title="Sub Role" columnMenu={ColumnMenuDefaultFilter} width="250px" />
                    <GridColumn title="Action" cell={renderActionCell} width="200px" />
                </Grid>
            </div>
        </div>  
    )
}